export default __webpack_public_path__ + "static/media/mission-main-img.32af152d.jpg";